import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useSubmitBranchWithUpload from 'api/productDetail/useSubmitBranchWithUpload/useSubmitBranchWithUpload';
import React, { useEffect, useState } from 'react';

const BranchWithUploadSubmitModal = ({ open, handleClose, originGuid }) => {
  const [file, setFile] = useState();

  const [uploadFile, loading] = useSubmitBranchWithUpload();

  const onClose = () => {
    handleClose();
    setFile();
  };

  const submitBranch = () => {
    uploadFile(file, originGuid, () => onClose());
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ثبت برنچ با فایل</DialogTitle>

      <DialogContent sx={{ width: '400px' }}>
        <FilledWrapper>
          <FilledLabel>انتخاب فایل</FilledLabel>
          <InputWrapper>
            {file ? 'تغییر فایل' : 'انتخاب کنید'}
            <FileInput
              type="file"
              onChange={e => setFile(e.target.files[0])}
              accept="application/*"
            />
          </InputWrapper>
        </FilledWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button onClick={handleClose} variant="contained" disabled={loading}>
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitBranch}
          loading={loading}
          disabled={!file}
        >
          آپلود
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BranchWithUploadSubmitModal;

const FilledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledLabel = styled.label``;

const InputWrapper = styled.div`
  width: 65%;
  background-color: #27348b;
  color: white;
  ${({ error }) => error && 'color: #d32f2f;'}
  position: relative;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
`;

const FileInput = styled.input`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0;
`;
